import React, { useState } from 'react';

import { CopyToClipboard } from '~/components/copy-to-clipboard/CopyToClipboard';
import { Markdown } from '~/components/markdown/Markdown';
import { useWatchlistSummary } from '~/hooks/use-watchlist-summary/useWatchlistSummary';

import { ErrorState } from './components/error-state/ErrorState';
import { LoadingState } from './components/loading-state/LoadingState';
import * as S from './WatchlistSummary.styles';

export interface WatchlistSummaryProps {
  watchlistId: string;
}

export const WatchlistSummary = ({
  watchlistId,
  ...rest
}: WatchlistSummaryProps) => {
  const { data, isLoading, isError, refetch } =
    useWatchlistSummary(watchlistId);

  const [markdownElement, setMarkdownElement] = useState<HTMLDivElement>();

  const handleClick = async () => {
    await refetch();
  };

  if (isLoading) {
    return (
      <S.WatchlistSummaryRoot data-testid="watchlist-summary-loading">
        <LoadingState />
      </S.WatchlistSummaryRoot>
    );
  }
  if (isError || !data) {
    return (
      <S.WatchlistSummaryRoot data-testid="watchlist-summary-error">
        <ErrorState onClick={handleClick} />
      </S.WatchlistSummaryRoot>
    );
  }

  return (
    <S.WatchlistSummaryRoot {...rest}>
      <S.FlexWrapper>
        <S.Content data-testid="watchlist-summary-content">
          <Markdown message={data.summary} onLoad={setMarkdownElement} />
        </S.Content>
        <div>
          {markdownElement && (
            <CopyToClipboard
              text={markdownElement.innerText}
              html={markdownElement.innerHTML}
            />
          )}
        </div>
      </S.FlexWrapper>
    </S.WatchlistSummaryRoot>
  );
};

WatchlistSummary.Styled = S;
